import React from 'react';
import { Card, ListGroup, Badge, Button } from 'react-bootstrap';
import { Trash3, XCircle } from 'react-bootstrap-icons';

/**
 * 保存した選手情報を表示するリストコンポーネント
 * 
 * @param {Object} props コンポーネントのプロパティ
 * @param {Object} props.racers 保存された選手データのオブジェクト
 * @param {Function} props.onSelectRacer 選手選択時のコールバック関数
 * @param {Function} props.onDeleteRacer 選手削除時のコールバック関数
 * @param {Function} props.onClearAll 全選手データ削除時のコールバック関数
 * @param {string|null} props.currentRacerId 現在表示中の選手番号
 */
const SavedRacersList = ({ 
  racers, 
  onSelectRacer, 
  onDeleteRacer, 
  onClearAll, 
  currentRacerId 
}) => {
  // 最後にアクセスした順にソート
  const sortedRacers = Object.entries(racers).sort((a, b) => {
    return new Date(b[1].lastAccessed) - new Date(a[1].lastAccessed);
  });

    if (!racers || Object.keys(racers).length === 0)  {
      return;
    }
  return (
    <Card className="saved-racers-card">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">検索履歴</h5>
        <Button 
          variant="outline-danger" 
          size="sm"
          onClick={onClearAll}
          title="キャッシュを全て削除"
        >
          <Trash3 size={16} /> キャッシュ削除
        </Button>
      </Card.Header>
      <ListGroup variant="flush">
        {sortedRacers.map(([racerId, data]) => (
          <ListGroup.Item 
            key={racerId}
            action
            active={racerId === currentRacerId}
            onClick={() => onSelectRacer(racerId)}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              <span className="racer-number me-2">{racerId}</span>
              <strong>{data.profile.name}</strong>
            </div>
            <div className="d-flex align-items-center">
              <Badge bg="secondary" pill className="me-2">
                {data.comments.length}件
              </Badge>
              <Button 
                variant="link" 
                className="p-0 delete-button"
                onClick={(e) => onDeleteRacer(racerId, e)}
                title="この選手のキャッシュを削除"
              >
                <XCircle size={18} color="#dc3545" />
              </Button>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      <Card.Footer className="text-muted">
        <small>最後にアクセスした順に表示されています</small>
      </Card.Footer>
    </Card>
  );
};

export default SavedRacersList;